export default __webpack_public_path__ + "static/man-0c927cbbb557d9239018a5fad977746e.png";